import { render, staticRenderFns } from "./CatalogsRequest.vue?vue&type=template&id=30f0a85c&lang=pug&"
import script from "./CatalogsRequest.vue?vue&type=script&lang=ts&"
export * from "./CatalogsRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports